import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Grid,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import styles from "./Cart.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import Parse from "../../API/ParseServer";
const OrderArtworkFrameItem: React.FC<{
  item: any;
}> = (props) => {
  const artwork = props.item.artwork;
  const frame = props.item.frame;
  const perimeter = Number(
    (Number(props.item.specifications.width) +
      Number(props.item.specifications.height) +
      (props.item.specifications.mountboard.color
        ? 4 * Number(props.item.specifications.mountboard.size)
        : 0)) *
      2
  );
  const area =
    (Number(props.item.specifications.width) +
      (props.item.specifications.mountboard.color
        ? 2 * Number(props.item.specifications.mountboard.size)
        : 0)) *
    (Number(props.item.specifications.height) +
      (props.item.specifications.mountboard.color
        ? 2 * Number(props.item.specifications.mountboard.size)
        : 0));
  const frameArea =
    (Number(props.item.specifications.width) +
      (props.item.specifications.mountboard.color
        ? 2 * Number(props.item.specifications.mountboard.size)
        : 0) +
      (2 * frame.get("width")) / 10) *
    (Number(props.item.specifications.height) +
      (props.item.specifications.mountboard.color
        ? 2 * Number(props.item.specifications.mountboard.size)
        : 0) +
      (2 * frame.get("width")) / 10);
  const criteria =
    window.screen.width < 900
      ? "m"
      : Number(props.item.specifications.width) <
        Number(props.item.specifications.height)
      ? "hl"
      : "wl";
  const cm =
    Math.max(
      Number(props.item.specifications.width),
      Number(props.item.specifications.height)
    ) < 7
      ? 5 - (Number(props.item.specifications.mountboard.size) * 2 || 0)
      : window.screen.width < 900
      ? 50 /
        (Number(props.item.specifications.width) +
          frame.get("width") / 5 +
          (Number(props.item.specifications.mountboard.size) * 2 || 0))
      : Number(props.item.specifications.width) <
        Number(props.item.specifications.height)
      ? 50 /
        (Number(props.item.specifications.height) +
          frame.get("width") / 5 +
          (Number(props.item.specifications.mountboard.size) || 0))
      : 50 /
        (Number(props.item.specifications.width) +
          frame.get("width") / 5 +
          (Number(props.item.specifications.mountboard.size) || 0));

  return (
    <Fragment>
      <TableRow
        key={props.item.objectId}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        <TableCell component="th" scope="row" sx={{ height: "auto" }}>
          {frame && criteria && cm ? (
            <Box
              sx={{
                position: "relative",
                width: `${
                  (Number(props.item.specifications.width) +
                    (Number(props.item.specifications.mountboard.size) || 0) *
                      2 +
                    frame.get("width") / 5) *
                  cm
                }px`,
                height: `${
                  (Number(props.item.specifications.height) /
                    Number(props.item.specifications.width)) *
                  (Number(props.item.specifications.width) +
                    (Number(props.item.specifications.mountboard.size) || 0) *
                      2 +
                    frame.get("width") / 5) *
                  cm
                }px`,
              }}
            >
              <Box
                className={`cube__face`}
                sx={{
                  borderImageSlice: "200",
                  background: "transparent",
                  boxShadow: "rgba(0, 0, 0, 0.7) 0px 2px 5px inset",
                  transition: "all 800ms",
                  borderStyle: "solid",
                  borderImageSource: `url(${frame.get("frameImage").url()})`,
                  borderImageWidth: `${(frame.get("width") / 10) * cm}px`,
                  borderImageRepeat: "stretch",
                  zIndex: "10",
                  width: `${
                    (Number(props.item.specifications.width) +
                      (Number(props.item.specifications.mountboard.size) || 0) *
                        2 +
                      frame.get("width") / 5) *
                    cm
                  }px`,
                  height: `${
                    (Number(props.item.specifications.height) +
                      (Number(props.item.specifications.mountboard.size) || 0) *
                        2 +
                      frame.get("width") / 5) *
                    cm
                  }px`,
                }}
              ></Box>
              <Box
                sx={{
                  width: `${
                    (Number(props.item.specifications.width) +
                      (Number(props.item.specifications.mountboard.size) || 0) *
                        2) *
                    cm
                  }px`,
                  height: `${
                    (Number(props.item.specifications.height) +
                      (Number(props.item.specifications.mountboard.size) || 0) *
                        2) *
                    cm
                  }px`,
                  border: `${
                    (Number(props.item.specifications.mountboard.size) || 0) *
                    cm
                  }px solid #${props.item.specifications.mountboard.color}`,

                  transition: "all 800ms",
                  position: "absolute",
                  zIndex: "10",
                  left: `${(frame.get("width") / 10) * cm}px`,
                  top: `${(frame.get("width") / 10) * cm}px`,
                }}
              ></Box>
              <Box
                sx={{
                  width: `${Number(props.item.specifications.width) * cm}px`,
                  height: `${Number(props.item.specifications.height) * cm}px`,
                  transition: "all 800ms",
                  background: `url(${artwork
                    .get("framingImage")
                    .url()}) no-repeat center`,
                  backgroundSize: "100% 100%",
                  position: "absolute",
                  zIndex: "20",
                  objectFit: "fill",
                  left: `${
                    ((Number(props.item.specifications.mountboard.size) || 0) +
                      frame.get("width") / 10) *
                    cm
                  }px`,
                  top: `${
                    ((Number(props.item.specifications.mountboard.size) || 0) +
                      frame.get("width") / 10) *
                    cm
                  }px`,
                }}
              ></Box>
            </Box>
          ) : (
            <Box
              sx={{
                width: "100%",
                aspectRatio: 1,
                backgroundColor: "gray",
              }}
            ></Box>
          )}
        </TableCell>
        <TableCell align="center"> {props.item.title}</TableCell>

        <TableCell align="center">
          {artwork.get("width")} x {artwork.get("height")} cm
        </TableCell>
        <TableCell align="center">{props.item.quantity}</TableCell>
        <TableCell align="center"> £{props.item.price}</TableCell>
      </TableRow>
    </Fragment>
  );
};

export default OrderArtworkFrameItem;
